import Vue from 'vue'
import define from '../systemAdminDefineModules/systemAdminDefineMutation.js'
// define-action
const URL = process.env.API_MASTER_URL
const header = define.state.header

export default {
  inputUpdateDefineInfo(store, payload) {
    store.commit('inputUpdateDefineInfo', payload)
  },
  inputUpdateHelpMsg(store, payload) {
    store.commit('inputUpdateHelpMsg', payload)
  },
  inputUpdateMail(store, payload) {
    store.commit('inputUpdateMail', payload)
  },
  cleareDefineInfo(store) {
    store.commit('cleareDefineInfo')
  },
  cleareHelpInfo(store) {
    store.commit('cleareHelpInfo')
  },
  cleareMailInfo(store) {
    store.commit('cleareMailInfo')
  },
  async updateDefineInfo(store) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          importantMsgTitle: store.state.importantMsgTitle,
          importantMsgValue: store.state.importantMsgValue,
          privacyPolicyPageUri: store.state.privacyPolicyPageUri,
          adminMailAddress: store.state.adminMailAddress
        }
      ]
    }
    await Vue.http.post(URL + '/v2/master/define/update', data, config)
    // 成功
    // 更新後の処理
  },
  async createHelpInfo(store) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          mode: '0',
          helpInfos: [store.state.helpInfo]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/Constants/HelpInfo/Maintenance',
      data,
      config
    )
    // 成功
    // 更新後の処理
    store.commit('setHelpInfos', response)
  },
  async setHelpInfos(store) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          mode: '1',
          helpInfos: [{}]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/Constants/HelpInfo/Maintenance',
      data,
      config
    )
    // 成功
    // 更新後の処理
    store.commit('setHelpInfos', response)
  },
  async deletehelpInfos(store, defineId) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          mode: '3',
          helpInfos: [
            {
              defineId: defineId
            }
          ]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/Constants/HelpInfo/Maintenance',
      data,
      config
    )
    // 成功
    // 更新後の処理
    store.commit('setCorporations', response)
  },
  async sendMail(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        mailTitle: store.state.mailInfo.mailTitle
          ? store.state.mailInfo.mailTitle
          : '',
        mailContent: store.state.mailInfo.mailContent
          ? store.state.mailInfo.mailContent
          : '',
        type: payload.type,
        tenantKey: payload.tenantKey
      }
    }
    await Vue.http.post(URL + '/v2/master/mail/send', data, config)
    // 成功
    // 更新後の処理
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/companiesCommonOptionModules/actions.js